import {UseInfiniteQueryOptions, useInfiniteQuery} from '@tanstack/react-query'
import {
    HttpGetReportDatesByPatientOptions,
    HttpGetReportDatesByPatientResponse,
    httpGetReportDatesByPatient
} from '@/features/medical-reports/http/medicalReports.http'
import {QUERY_KEYS} from '@/queryClient'

export const useGetReportDatesByPatient = (
    params: HttpGetReportDatesByPatientOptions['params'],
    options?: Pick<UseInfiniteQueryOptions<HttpGetReportDatesByPatientResponse>, 'enabled'>
) =>
    useInfiniteQuery({
        queryKey: [QUERY_KEYS.MEDICAL_REPORT_DATES_BY_PATIENT, params],
        queryFn: ({pageParam = 1}) => httpGetReportDatesByPatient({params: {...params, page: pageParam}}),
        ...options,
        initialPageParam: 1,
        getNextPageParam: ({meta}) => (meta.currentPage < meta.lastPage ? meta.currentPage + 1 : null)
    })
